(function () {
  function formatMoneyFromTemplate(cents, template) {
    let value = (cents / 100).toFixed(2);
    let match = String(template).match(/^([^0-9]*)([0-9,]+\.[0-9]{2}|[0-9,]+)(.*)$/);
    if (match) {
      return match[1] + value + match[3];
    }
    return '$' + value;
  }

  function initButton(submit) {
    if (submit.dataset.atcPriceBound === 'true') {
      return;
    }
    let sectionId = submit.id.replace('ProductSubmitButton-', '');
    if (document.querySelector('plug-buy-more-save-more[data-section-id="' + sectionId + '"]')) {
      return;
    }
    let priceEl = submit.querySelector('[data-atc-price]');
    let qtyEl = document.getElementById('Quantity-' + sectionId);
    if (!priceEl || !qtyEl) {
      return;
    }
    let unitPrice = Number(submit.dataset.unitPrice);
    if (!Number.isFinite(unitPrice)) {
      return;
    }
    submit.dataset.atcPriceBound = 'true';

    function update() {
      let qty = Number(qtyEl.value) || 0;
      let totalCents = Math.round(unitPrice * qty);
      priceEl.textContent = formatMoneyFromTemplate(totalCents, priceEl.textContent);
    }

    qtyEl.addEventListener('input', update);
    qtyEl.addEventListener('change', update);
    update();
  }

  function initAll() {
    document.querySelectorAll('[data-atc-submit]').forEach(initButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
